/**
 * "Contempla rápido" na lista de Grupos — só dados, sem React.
 *
 * Reunião de 14/10/2026: nenhum grupo some da lista; os que contemplam mais
 * rápido ganham destaque. A medida (escolhida pelo Rick) é a chance de UMA
 * cota ser contemplada por mês: contemplados por assembleia nas 3 últimas
 * (sorteio + todas as modalidades) ÷ cotas do grupo. Contemplados por mês
 * sozinho daria o selo sempre aos grupos grandes; dividir pelas cotas
 * compara grupo de 320 com grupo de 5.040.
 *
 * O selo vai para os 20% melhores DE CADA SEGMENTO: imóveis contemplam bem
 * mais devagar que automóveis, e um ranking único nunca daria selo a imóvel.
 * Só entram no ranking os grupos com vaga: no PROD de 14/10, 12 dos 18 selos
 * de automóvel iriam para grupos lotados, que o vendedor não tem como vender.
 * Os números vêm da view servopa_group_lance_resumo (migration 252).
 */

import type { LanceResumo, Segmento } from './lanceRanking';

export const FRACAO_DESTAQUE = 0.2;

/** Chance por mês de uma cota (0–1), ou null sem dado para afirmar. */
export const chancePorMes = (l: Pick<LanceResumo, 'contemplados_mes_recente' | 'cotas_grupo'>): number | null => {
  const contemplados = l.contemplados_mes_recente;
  const cotas = l.cotas_grupo;
  if (contemplados == null || cotas == null || !(cotas > 0) || !(contemplados > 0)) return null;
  return contemplados / cotas;
};

/** "1 em cada 53 cotas" — o jeito de dizer ao cliente. */
export const textoUmEmCada = (chance: number): string =>
  `1 em cada ${Math.max(1, Math.round(1 / chance)).toLocaleString('pt-BR')} cotas`;

/**
 * Os grupos com selo: os 20% de maior chance por mês dentro do segmento
 * (arredondando para cima, no mínimo 1 quando o segmento tem dado), entre os
 * `comVaga` — sem a lista, todos entram.
 */
export const gruposQueContemplamRapido = (
  resumos: Iterable<LanceResumo>,
  comVaga?: ReadonlySet<number>,
): Set<number> => {
  const porSegmento = new Map<Segmento, { grupo: number; chance: number }[]>();
  for (const l of resumos) {
    const chance = chancePorMes(l);
    if (chance == null || (l.segment !== 'M' && l.segment !== 'I')) continue;
    if (comVaga && !comVaga.has(l.group_number)) continue;
    const lista = porSegmento.get(l.segment) ?? [];
    lista.push({ grupo: l.group_number, chance });
    porSegmento.set(l.segment, lista);
  }
  const selo = new Set<number>();
  for (const lista of porSegmento.values()) {
    lista.sort((a, b) => b.chance - a.chance);
    const corte = lista[Math.ceil(lista.length * FRACAO_DESTAQUE) - 1]?.chance;
    // Empate no corte entra também: dois grupos iguais não podem ficar um
    // com selo e o outro sem.
    for (const g of lista) if (corte != null && g.chance >= corte) selo.add(g.grupo);
  }
  return selo;
};
